module.exports = require('./toPairsIn');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/entriesIn.js
// module id = 465
// module chunks = 0